export { Spine } from '@pixi-spine/loader-uni';
export * from '@pixi-spine/base';
export { SkeletonBounds } from '@pixi-spine/runtime-4.1';
//# sourceMappingURL=index.mjs.map
